import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15340272"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between mb-2 flex-wrap gap-2" }
const _hoisted_2 = { class: "flex gap-1 flex-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "dcs-strip mb-3"
}
const _hoisted_4 = { class: "dcs-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kpi-label" }, "Ambient", -1))
const _hoisted_6 = { class: "kpi-value text-sm" }
const _hoisted_7 = { class: "dcs-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kpi-label" }, "Humidity", -1))
const _hoisted_9 = { class: "kpi-value text-sm" }
const _hoisted_10 = { class: "dcs-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kpi-label" }, "Irradiance", -1))
const _hoisted_12 = { class: "kpi-value text-sm" }
const _hoisted_13 = { class: "dcs-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kpi-label" }, "Wind", -1))
const _hoisted_15 = { class: "kpi-value text-sm" }
const _hoisted_16 = {
  key: 0,
  class: "dcs-item"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kpi-label" }, "DCS ts", -1))
const _hoisted_18 = { class: "kpi-value text-sm" }
const _hoisted_19 = { class: "ops-grid" }
const _hoisted_20 = {
  key: 0,
  class: "ops-block"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label mb-2" }, "Subsystems", -1))
const _hoisted_22 = { class: "comp-list" }
const _hoisted_23 = {
  key: 0,
  class: "text-xs text-orange-500 ml-auto"
}
const _hoisted_24 = {
  key: 1,
  class: "ops-block"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label mb-2" }, "MDA ingest", -1))
const _hoisted_26 = { class: "ops-metric" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Last sample", -1))
const _hoisted_28 = { class: "kpi-value text-base" }
const _hoisted_29 = { class: "ops-metric mt-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Age", -1))
const _hoisted_31 = { class: "ops-metric mt-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Samples (24h)", -1))
const _hoisted_33 = { class: "kpi-value text-base" }
const _hoisted_34 = {
  key: 2,
  class: "ops-block"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label mb-2" }, "CSS telemetry", -1))
const _hoisted_36 = { class: "ops-metric" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Pending / failed / sent", -1))
const _hoisted_38 = { class: "kpi-value text-base" }
const _hoisted_39 = { class: "ops-metric mt-2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Dispatcher", -1))
const _hoisted_41 = { class: "kpi-value text-base" }
const _hoisted_42 = {
  key: 3,
  class: "ops-block"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label mb-2" }, "Scheduler", -1))
const _hoisted_44 = { class: "ops-metric" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "State", -1))
const _hoisted_46 = { class: "kpi-value text-base" }
const _hoisted_47 = {
  key: 0,
  class: "ops-metric mt-2"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Last processed hour", -1))
const _hoisted_49 = { class: "kpi-value text-base" }
const _hoisted_50 = {
  key: 1,
  class: "text-sm text-color-secondary mt-2"
}
const _hoisted_51 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label mb-2" }, "Recent audit activity", -1))
const _hoisted_53 = { class: "audit-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WSubTitle = _resolveComponent("WSubTitle")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PTag = _resolveComponent("PTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_WSubTitle, { text: "Plant & system status" }),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.canFlush && (_ctx.telemetry?.pending || 0) > 0)
          ? (_openBlock(), _createBlock(_component_PButton, {
              key: 0,
              loading: _ctx.busyAction === 'flush',
              icon: "pi pi-send",
              label: "Flush telemetry",
              outlined: "",
              rounded: "",
              size: "small",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('flush-telemetry')))
            }, null, 8, ["loading"]))
          : _createCommentVNode("", true),
        (_ctx.canScheduler && _ctx.scheduler?.running && !_ctx.scheduler?.paused)
          ? (_openBlock(), _createBlock(_component_PButton, {
              key: 1,
              loading: _ctx.busyAction === 'pause',
              icon: "pi pi-pause",
              label: "Pause",
              outlined: "",
              rounded: "",
              size: "small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('scheduler', 'pause')))
            }, null, 8, ["loading"]))
          : _createCommentVNode("", true),
        (_ctx.canScheduler && _ctx.scheduler?.running && _ctx.scheduler?.paused)
          ? (_openBlock(), _createBlock(_component_PButton, {
              key: 2,
              loading: _ctx.busyAction === 'resume',
              icon: "pi pi-play",
              label: "Resume",
              outlined: "",
              rounded: "",
              size: "small",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('scheduler', 'resume')))
            }, null, 8, ["loading"]))
          : _createCommentVNode("", true),
        (_ctx.canScheduler && _ctx.scheduler?.running)
          ? (_openBlock(), _createBlock(_component_PButton, {
              key: 3,
              loading: _ctx.busyAction === 'trigger_hourly',
              icon: "pi pi-clock",
              label: "Trigger hourly",
              outlined: "",
              rounded: "",
              size: "small",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('scheduler', 'trigger_hourly')))
            }, null, 8, ["loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.dcs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.fmt(_ctx.dcs.ambient_temp)) + " °C", 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.fmt(_ctx.dcs.humidity)) + " %", 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.fmt(_ctx.dcs.irradiance)) + " W/m²", 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.fmt(_ctx.dcs.wind_speed)) + " m/s", 1)
          ]),
          (_ctx.dcs.ts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.dcs.ts), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      (_ctx.health)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.health.components, (c) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: c.key,
                  class: "comp-row"
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["comp-dot", c.effective ? 'on' : 'off'])
                  }, null, 2),
                  _createElementVNode("span", null, _toDisplayString(c.label), 1),
                  (c.simulated_offline)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "sim offline"))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.mda)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.mda.last_ingest_at || '—'), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", {
                class: _normalizeClass(["kpi-value text-base", _ctx.ageClass])
              }, _toDisplayString(_ctx.ageLabel), 3)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.mda.samples_last_24h.toLocaleString()), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.telemetry)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.telemetry.pending) + " / " + _toDisplayString(_ctx.telemetry.failed) + " / " + _toDisplayString(_ctx.telemetry.sent), 1)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_PTag, {
                  severity: _ctx.telemetry.dispatcher_running ? 'success' : 'secondary'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.telemetry.dispatcher_running ? 'running' : 'stopped'), 1)
                  ]),
                  _: 1
                }, 8, ["severity"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.scheduler)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                (!_ctx.scheduler.running)
                  ? (_openBlock(), _createBlock(_component_PTag, {
                      key: 0,
                      severity: "secondary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("disabled")
                      ]),
                      _: 1
                    }))
                  : (_ctx.scheduler.paused)
                    ? (_openBlock(), _createBlock(_component_PTag, {
                        key: 1,
                        severity: "warning"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("paused")
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_PTag, {
                        key: 2,
                        severity: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("running")
                        ]),
                        _: 1
                      }))
              ])
            ]),
            (_ctx.scheduler.last_processed_hour)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.scheduler.last_processed_hour), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.scheduler.reason)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.scheduler.reason), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.auditRecent?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("ul", _hoisted_53, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.auditRecent.slice().reverse(), (line, idx) => {
              return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(line), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}